export interface AppConfig {
    tmsId: string;
}

export function getConfig():AppConfig {
  return window.sgmeConfiguration;
}
